import { useState, useEffect } from 'react';
import { Svg, Track, Progress, SIZE, RADIUS } from './styles';

const isTabHidden = () => typeof document !== 'undefined' && document.hidden;

// Anel de contagem de 30s da tela de espera de aprovação de workstation,
// sincronizado com a cadência do poll de status (useWorkstationStatusPolling):
// completa e reinicia o traço a cada 30s via animação CSS em loop, e pausa
// quando a aba fica oculta — mesma lógica de visibilidade usada pelo poll.
const CountdownRing = () => {
  const [paused, setPaused] = useState(isTabHidden());

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const handleVisibilityChange = () => setPaused(isTabHidden());
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return (
    <Svg
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      role="img"
      aria-label="aguardando"
    >
      <Track cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} />
      <Progress cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} paused={paused} />
    </Svg>
  );
};

export default CountdownRing;
